/* KILL NOTHING — tema Shopify v5. Nessuna libreria esterna.
   Menu mobile, dropdown, carrello a cassetto (AJAX + Section Rendering), form lista con consenso obbligatorio,
   filtri collezione, scheda prodotto (varianti, galleria per colore, riga 10%, soglia spedizione), guida taglie. */
(function () {
  'use strict';
  var body = document.body;
  var cfgEl = document.getElementById('kn-config');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : { strings: {}, threshold: 5900, cartTotal: 0 };
  var S = CFG.strings || {};
  var cartTotal = CFG.cartTotal || 0;

  /* ---------- prezzi ---------- */
  function fmtNum(cents, dec, thou, sep) {
    var n = (cents / 100).toFixed(dec).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return n[1] ? n[0] + sep + n[1] : n[0];
  }
  function money(cents, short) {
    var f = CFG.moneyFormat || '€{{amount}}';
    var noDec = short && cents % 100 === 0;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return fmtNum(cents, noDec ? 0 : 2, ',', '.');
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, noDec ? 0 : 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, noDec ? 0 : 2, "'", '.');
        case 'amount_with_space_separator': return fmtNum(cents, noDec ? 0 : 2, ' ', ',');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- menu mobile ---------- */
  var burger = document.querySelector('.burger'), m = document.getElementById('mnav');
  function trap(root, e, close) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(root.querySelectorAll('a,button,input,select,[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null && !x.disabled; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function mopen() { m.classList.add('open'); burger.setAttribute('aria-expanded', 'true'); body.style.overflow = 'hidden'; var x = m.querySelector('.x'); x && x.focus(); }
  function mclose() { m.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); body.style.overflow = ''; burger.focus(); }
  if (burger && m) {
    burger.addEventListener('click', mopen);
    m.querySelectorAll('[data-mclose]').forEach(function (e) { e.addEventListener('click', mclose); });
    m.addEventListener('keydown', function (e) { trap(m, e, mclose); });
  }

  /* ---------- dropdown desktop ---------- */
  document.querySelectorAll('.dd>button').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.parentNode.classList.toggle('open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    b.parentNode.addEventListener('keydown', function (e) { if (e.key === 'Escape') { b.parentNode.classList.remove('open'); b.setAttribute('aria-expanded', 'false'); b.focus(); } });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.dd.open').forEach(function (d) { if (!d.contains(e.target)) { d.classList.remove('open'); d.querySelector('button').setAttribute('aria-expanded', 'false'); } });
  });

  /* ---------- carrello ---------- */
  var lastFocus = null;
  function drawer() { return document.querySelector('aside[data-cart-drawer]'); }
  function copen() {
    var d = drawer(); if (!d) return false;
    lastFocus = document.activeElement;
    body.classList.add('cart-open'); body.style.overflow = 'hidden';
    setTimeout(function () { var x = d.querySelector('.x'); (x || d).focus(); }, 50);
    return true;
  }
  function cclose() { body.classList.remove('cart-open'); body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]');
    if (o && drawer()) { e.preventDefault(); copen(); return; }
    if (e.target.closest('[data-cclose]')) { e.preventDefault(); cclose(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!body.classList.contains('cart-open')) return;
    trap(drawer(), e, cclose);
  });

  function applyCartSections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var tmp = document.createElement('div'); tmp.innerHTML = sections['cart-drawer'];
    var fresh = tmp.querySelector('[data-cart-drawer]'), d = drawer();
    if (fresh && d) d.innerHTML = fresh.innerHTML;
    var meta = tmp.querySelector('[data-cart-meta]');
    if (meta) updateCount(+meta.dataset.count, +meta.dataset.total);
  }
  function updateCount(count, total) {
    cartTotal = total;
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = count; n.hidden = count === 0; });
    document.querySelectorAll('[data-cart-open]').forEach(function (a) { a.setAttribute('aria-label', a.getAttribute('aria-label').replace(/\d+/, count)); });
    if (window.knShip) window.knShip();
  }
  function post(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function cartErr(msg) { var e = document.querySelector('[data-cart-err]'); if (e) { e.textContent = msg || S.cartError; e.classList.add('on'); } }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-drawer] [data-line]');
    if (b) {
      e.preventDefault();
      var page = !!document.querySelector('[data-cart-page]');
      b.classList.add('is-loading');
      post(CFG.cartChangeUrl + '.js', { line: +b.dataset.line, quantity: +b.dataset.qty, sections: page ? [] : ['cart-drawer'] })
        .then(function (j) { if (page) location.reload(); else applyCartSections(j.sections); })
        .catch(function (err) { b.classList.remove('is-loading'); cartErr(err && err.description); });
      return;
    }
    var a = e.target.closest('[data-cart-drawer] [data-add]');
    if (a) {
      e.preventDefault(); a.classList.add('is-loading');
      post(CFG.cartAddUrl + '.js', { items: [{ id: +a.dataset.add, quantity: 1 }], sections: ['cart-drawer'] })
        .then(function (j) { if (document.querySelector('[data-cart-page]')) location.reload(); else applyCartSections(j.sections); })
        .catch(function (err) { a.classList.remove('is-loading'); cartErr(err && err.description); });
    }
  });

  /* ---------- form lista: email + consenso obbligatorio ---------- */
  document.querySelectorAll('form[data-wlform]').forEach(function (f) {
    var em = f.querySelector('input[type=email]'), cb = f.querySelector('input[type=checkbox]'), err = f.querySelector('.err');
    if (!em) return;
    function msg(t) { if (err) { err.textContent = t; err.classList.toggle('on', !!t); } }
    cb && cb.addEventListener('change', function () { if (cb.checked) msg(''); });
    f.addEventListener('submit', function (e) {
      if (!em.value || !em.checkValidity()) { e.preventDefault(); msg(S.emailInvalid); em.focus(); return; }
      if (cb && !cb.checked) { e.preventDefault(); msg(S.consentRequired); cb.focus(); return; }
      msg('');
    });
    var ok = f.querySelector('.ok'); if (ok) { ok.focus(); }
  });

  /* ---------- footer: fisarmonica su mobile ---------- */
  var mq = window.matchMedia('(max-width: 860px)');
  function acc() { document.querySelectorAll('details.fcol').forEach(function (d) { if (mq.matches) d.removeAttribute('open'); else d.setAttribute('open', ''); }); }
  acc(); mq.addEventListener ? mq.addEventListener('change', acc) : mq.addListener(acc);

  /* ---------- collezione: filtri e ordinamento ---------- */
  document.querySelectorAll('form[data-filters]').forEach(function (f) {
    f.querySelectorAll('select[data-filter]').forEach(function (s) {
      s.addEventListener('change', function () {
        var p = new URLSearchParams();
        new FormData(f).forEach(function (v, k) { if (v !== '') p.append(k, v); });
        var q = p.toString();
        location.href = f.getAttribute('action') + (q ? '?' + q : '');
      });
    });
  });

  /* ---------- guida taglie ---------- */
  var sg = document.getElementById('sizeguide');
  if (sg) {
    document.querySelectorAll('[data-sg]').forEach(function (b) { b.addEventListener('click', function () { if (sg.showModal) sg.showModal(); else sg.setAttribute('open', ''); }); });
    var sx = sg.querySelector('[data-sgclose]'); sx && sx.addEventListener('click', function () { sg.close(); });
    sg.addEventListener('click', function (e) { if (e.target === sg) sg.close(); });
  }

  /* ---------- scheda prodotto ---------- */
  var pdp = document.querySelector('[data-product]');
  var pj = document.querySelector('[data-product-json]');
  if (pdp && pj) {
    var variants = JSON.parse(pj.textContent);
    var form = pdp.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('[data-variant-id]');
    var atc = form && form.querySelector('[data-atc]');
    var atcM = document.querySelector('[data-atc-m]');
    var inputs = form ? [].slice.call(form.querySelectorAll('input[data-opt]')) : [];
    var gallery = pdp.querySelector('[data-gallery]');
    var twinEl = pdp.querySelector('[data-twin-variants]');
    var twinMap = twinEl ? JSON.parse(twinEl.textContent) : null;
    var twinA = pdp.querySelector('[data-twin]');
    var colorIdx = -1;
    inputs.forEach(function (i) { if (i.closest('.swc')) colorIdx = +i.dataset.opt; });
    var current = variants.filter(function (v) { return idInput && v.id === +idInput.value; })[0] || variants[0];

    function selected() {
      var sel = [];
      inputs.forEach(function (i) { if (i.checked) sel[+i.dataset.opt] = i.value; });
      return sel;
    }
    function match(sel) {
      return variants.filter(function (v) { return v.options.every(function (o, k) { return sel[k] === undefined || sel[k] === o; }); })[0];
    }
    function markAvail(sel) {
      inputs.forEach(function (i) {
        var k = +i.dataset.opt, s2 = sel.slice(); s2[k] = i.value;
        var ok = variants.some(function (v) { return v.available && v.options.every(function (o, j) { return s2[j] === undefined || s2[j] === o; }); });
        i.classList.toggle('na', !ok);
      });
    }
    window.knShip = function () {
      var bar = pdp.querySelector('[data-ship-bar]'), txt = pdp.querySelector('[data-ship-text]');
      if (!bar || !current) return;
      var after = cartTotal + current.price, rem = CFG.threshold - after;
      var pct = CFG.threshold > 0 ? Math.min(100, Math.floor(after * 100 / CFG.threshold)) : 100;
      bar.style.width = pct + '%';
      txt.innerHTML = rem > 0 ? S.toFree.replace('%A', esc(money(rem, true))) : esc(S.shipsFree);
    };
    function gal(v) {
      if (!gallery) return;
      var tiles = [].slice.call(gallery.querySelectorAll('.g[data-media-id]'));
      var color = colorIdx > -1 ? String(v.options[colorIdx]).toLowerCase() : null;
      var hasColor = tiles.some(function (t) { return t.dataset.color; });
      if (hasColor && color) tiles.forEach(function (t) { t.hidden = !!t.dataset.color && t.dataset.color !== color; });
      var feat = v.featured_media && gallery.querySelector('.g[data-media-id="' + v.featured_media.id + '"]');
      var first = tiles.filter(function (t) { return !t.hidden; })[0];
      if (feat && !feat.hidden && feat !== first) { gallery.insertBefore(feat, first); first = feat; }
      tiles.forEach(function (t) { t.classList.toggle('big', t === first); });
      if (first) {
        var bi = first.querySelector('img');
        if (bi) { bi.setAttribute('sizes', '(max-width: 860px) 84vw, 54vw'); bi.loading = 'eager'; }
        var z = gallery.querySelector('[data-zoom] img');
        if (z && bi) { z.srcset = bi.srcset; z.src = bi.src; }
      }
    }
    var sizeInputs = inputs.filter(function (i) { return i.closest('.sizes'); });
    var needSize = !!(atc && atc.hasAttribute('data-need-size'));
    function sizeOk() { return !needSize || sizeInputs.some(function (i) { return i.checked; }); }
    function render(v) {
      var sel = selected();
      markAvail(sel);
      inputs.forEach(function (i) { if (i.checked) { var l = form.querySelector('[data-opt-label="' + i.dataset.opt + '"]'); if (l) l.textContent = i.value; } });
      var mv = document.querySelector('[data-mvar]'); if (mv) mv.textContent = sel.filter(function (x) { return x !== undefined; }).join(' · ');
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = S.unavailable; }
        if (atcM) { atcM.disabled = true; atcM.textContent = S.unavailable; }
        return;
      }
      current = v;
      idInput.value = v.id;
      var pr = money(v.price, true);
      document.querySelectorAll('[data-price]').forEach(function (p) { p.textContent = pr; });
      var cmp = pdp.querySelector('[data-compare]'); if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); cmp.textContent = money(v.compare_at_price || 0, true); }
      if (atc) { atc.disabled = !v.available; atc.textContent = !v.available ? S.soldOut : (sizeOk() ? atc.dataset.label.replace('%P', pr) : S.chooseSize); }
      if (atcM) { atcM.disabled = !v.available; atcM.textContent = !v.available ? S.soldOut : (sizeOk() ? S.addToCart : S.chooseSize); }
      var ten = pdp.querySelector('[data-ten]');
      if (ten) {
        var sn = ten.dataset.sanctuary ? esc(ten.dataset.sanctuary) : '<span class="ph">[SANCTUARY]</span>';
        if (ten.dataset.sanctuary && ten.dataset.sanctuaryUrl) sn = '<a class="sl" href="' + esc(ten.dataset.sanctuaryUrl) + '" target="_blank" rel="noopener">' + sn + '</a>';
        ten.innerHTML = esc(S.tenLine).replace('%S', sn).replace('%A', esc(money(Math.floor(v.price * (S.donationPct || CFG.donationPct || 15) / 100))));
      }
      if (twinA && twinMap && twinMap[v.title]) twinA.href = twinA.href.split('?')[0] + '?variant=' + twinMap[v.title];
      gal(v);
      window.knShip();
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    }
    inputs.forEach(function (i) { i.addEventListener('change', function () { if (i.closest('.sizes')) { var b = i.closest('.sizes'); b.classList.remove('need'); var e1 = form && form.querySelector('[data-form-err]'); if (e1) { e1.textContent = ''; e1.classList.remove('on'); } } render(match(selected())); }); });
    if (inputs.length) { markAvail(selected()); gal(current); }
    var mbar = document.querySelector('.mbar');
    if (mbar && atc && 'IntersectionObserver' in window) {
      mbar.classList.add('off');
      new IntersectionObserver(function (en) { mbar.classList.toggle('off', en[0].isIntersecting || en[0].boundingClientRect.top > 0); }).observe(atc);
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!sizeOk()) {
        var box = form.querySelector('.sizes');
        if (box) { box.classList.add('need'); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); var f = box.querySelector('input:not(.na)'); if (f) f.focus({ preventScroll: true }); }
        var e0 = form.querySelector('[data-form-err]'); if (e0) { if (box) box.parentNode.insertBefore(e0, box.nextSibling); e0.textContent = S.sizeRequired || S.chooseSize; e0.classList.add('on'); }
        return;
      }
      var err = form.querySelector('[data-form-err]');
      if (err) { err.textContent = ''; err.classList.remove('on'); }
      var fd = new FormData(form);
      var payload = { items: [{ id: +fd.get('id'), quantity: 1 }], sections: ['cart-drawer'] };
      [atc, atcM].forEach(function (b) { b && b.classList.add('is-loading'); });
      post(CFG.cartAddUrl + '.js', payload).then(function (j) {
        applyCartSections(j.sections); copen();
      }).catch(function (x) {
        if (err) { err.textContent = (x && (x.description || x.message)) || S.cartError; err.classList.add('on'); }
      }).then(function () { [atc, atcM].forEach(function (b) { b && b.classList.remove('is-loading'); }); });
    });
  }
})();
